/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nsc-or[_ngcontent-%COMP%]{padding-bottom:1.75em}.nsc-or[_ngcontent-%COMP%]   strong[_ngcontent-%COMP%]{font-weight:700;font-style:normal;color:#000}@media (min-width:768px){.nsc-or[_ngcontent-%COMP%]{padding-bottom:.75em}}"];
export { styles as styles };
